import { ReactNode } from "react";
import { getFirefoxCssFix } from "../commonfunctions/getFirefoxCssFix";

type AddModelProps = {
  children?: ReactNode; // Optional children prop
  noScroll?: boolean;
  ModelHight?: string;
  // Overrides the default responsive padding below - use when a design calls
  // for fixed spacing instead (e.g. Bundle Activation's 16px/24px redline).
  padding?: string;
}
export default function AddModel({ children, noScroll, ModelHight, padding }: AddModelProps) {
  return (
    <div className={`bg-white mt-1 ${padding || 'py-2 pl-3 sm:pl-6 pr-2 sm:pr-0'} rounded-lg ${ModelHight ? ModelHight : 'h-addsreenheight'}`}>
      <div
        className={`h-full overflow-x-hidden ${!noScroll ? `${getFirefoxCssFix('scroll')} overflow-auto` : 'overflow-hidden'} add-model-scroll-container`}
      >
        {children}
      </div>
    </div>
  )
}
